import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App.tsx';
import { QueryProvider } from '@/app/providers/QueryProvider';
import './index.scss';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </React.StrictMode>,
);
